import { MembershipRequestState } from './types';

export const state = (): MembershipRequestState => initialState();

export const initialState = (): MembershipRequestState => ({
  membershipRequests: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdDate'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['memberFullName', 'memberNumber'],
    },
  },
  membershipRequestsTotalOpenCount: 0,
});
